export default "__VITE_ASSET__6NsIvAi1__"